// Period & overtime progression (002 FR-007/008/009, parity with web baseline 001).
//
// Regulation = periods 1..regularPeriods (default 2). When a regular period ends the
// match advances automatically. Overtime periods (up to maxPeriods, default 4) are only
// entered while the score is TIED; otherwise the match stops at the end of regulation.

export function nextPeriod({ period, homeScore, awayScore, regularPeriods = 2, maxPeriods = 4 }) {
  if (period < regularPeriods) {
    return { period: period + 1, advanced: true, reason: 'regulation' };
  }
  if (period >= maxPeriods) {
    return { period, advanced: false, reason: 'final' };
  }
  if (homeScore === awayScore) {
    return { period: period + 1, advanced: true, reason: 'overtime' };
  }
  return { period, advanced: false, reason: 'decided' };
}
